<template>
  <div v-if="errorMessages && errorMessages.length" class="v-messages error--text">
    <div class="v-messages__wrapper">
      <div v-for="error in errorMessages" :key="error" class="v-messages__message">
        {{ error }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseFormErrors',

  props: {
    errorMessages: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
};
</script>
